import { useApplicationContext } from 'context/ApplicationContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { DreConfig } from 'pages/financeiro/dre/configuracao/components';
import { DreConfigProvider } from 'pages/financeiro/dre/configuracao/contexts';

export function DreConfigForm() {
    const { user } = useApplicationContext();
    const { alertNotPermission } = usePermissionsContext();

    if (user.tipoUsuario.tipoUsuarioEnum !== 'SUPORTE_CISS') return alertNotPermission();

    return (
        <DreConfigProvider>
            <DreConfig />
        </DreConfigProvider>
    );
}
